import React from 'react';

export interface IToolsContext {
  showDevTools: boolean;
}

export const ToolsContext = React.createContext<IToolsContext>({
  showDevTools: false,
});

export const ToolsProvider: React.FC<{ showDevTools: boolean; children: React.ReactNode }> = ({
  showDevTools,
  children,
}) => {
  return <ToolsContext.Provider value={{ showDevTools }}>{children}</ToolsContext.Provider>;
};
